import React, { useEffect, useState } from 'react';
import { useForm } from "react-hook-form";
import { Container, Typography, InputLabel, Paper, Divider, Button, Grid, CircularProgress } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl'
import { bindActionCreators } from 'redux';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@material-ui/icons/Edit';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { NotificationActions, PointManagementActions } from '../../../store';

const style = theme => ({
    root: {
        height: '100%',
        overflow: 'hidden'
    },
    paper: {
        overflow: 'hidden',
        paddingTop: '10px',
        marginBottom: '4px'
    },
    form: {
        height: '100%',
        padding: '25px',
    },

    infoTitle: {
        "& h1": {
            float: 'left'
        },
        "& div": {
            width: '100px',
            display: 'block',
            margin: '0 0 5px auto'
        }
    },
    headerTitle: {
        fontWeight: 'bold',
    },
    loadingBackground: theme.loadingBackground,
    loading: theme.loading
})

const pointManagementSelector = (state) => state.PointManagements;
const IdentitySelector = (state) => state.Identity;

const PointManagementDetail = (props) => {
    // useDispatch で store に紐付いた dispatch を取得。
    const dispatch = useDispatch();
    const pointManagementActions = bindActionCreators(PointManagementActions, dispatch);
    const notificationActions = bindActionCreators(NotificationActions, dispatch);

    // useSelector で store の state を取得。
    const { editing, nowWainting } = useSelector(pointManagementSelector);
    const { token, permissions } = useSelector(IdentitySelector);

    const { classes } = props;

    /**
     *
     * 戻るボタン押下時の処理
     *
     */
    const onBackClick = () => {
        props.onCancel();
    }

    /**
     *
     * 編集ボタン押下時の処理
     *
     */
    const onEdit = () => {
        props.onEdit();
    }

    // 編集ボタンの活性・非活性の制御
    var editButtonDisabled = true;
    if (permissions != null && permissions != undefined && permissions.fid5_5 != null && (permissions.fid5_5.value.value & 2) == 2) {
        // ポイント管理の編集権限の有りの場合のみ編集ボタンを活性（fid5_5：ポイント管理）
        editButtonDisabled = false;
    }

    // ポイント率  小数点処理
    var pointRate = Number(editing.point_rate).toFixed(1);
    // 原子負担割合（OKICA）小数点処理
    var sourceRatioOkica = Number(editing.source_ratio_o).toFixed(1);

    // ポイント種別
    var pointKbn = '';
    if (editing.point_kbn == 1) {
        pointKbn = <FormattedMessage id="PointManagement.PointKbn.Card" />;
    } else if (editing.point_kbn == 2)
    {
        pointKbn = <FormattedMessage id="PointManagement.PointKbn.Qr" />;
    } else {
        pointKbn = 'ポイント種別の値に誤りがあります。'
    }

    // 適用区分
    var applyKbn = '';
    if (editing.apply_kbn) {
        applyKbn = <FormattedMessage id="PointManagement.Valid" />;
    } else {
        applyKbn = <FormattedMessage id="PointManagement.Invalid" />;
    }

    return (
        <Container className={classes.root} maxWidth={false}>
            <Paper className={classes.paper}>
                <Grid container className={classes.form} spacing={2} >
                    <Grid item xs={12}>
                        <Typography component="h1" variant="inherit">{<FormattedMessage id="PointManagement.PointSettingDetails" />}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <div className={classes.infoTitle}>
                            <Typography id="infoTitle" component="h2" variant="inherit">{<FormattedMessage id="PointManagement.PointInformation" />}</Typography>
                            <div>
                                <Button fullWidth variant="contained" size="medium" color="primary"
                                    onClick={(e) => onEdit(e)}
                                    disabled={editButtonDisabled}
                                    endIcon={<EditIcon />}>
                                    <FormattedMessage id="Button.Edit" />
                                </Button>
                            </div>
                        </div>
                        <Divider />
                    </Grid>

                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"Merchant.Name"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.merchant_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.PointName"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.point_name}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.PointKbn"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{pointKbn}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.Period"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{editing.period}</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.PointRate"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{pointRate}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.OKICASourceRatio"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{sourceRatioOkica}%</InputLabel>
                    </Grid>
                    <Grid item xs={4}>
                        <InputLabel component="legend" className={classes.headerTitle}><FormattedMessage id={"PointManagement.ApplicableCategory"} /></InputLabel>
                    </Grid>
                    <Grid item xs={8}>
                        <InputLabel component="legend">{applyKbn}</InputLabel>
                    </Grid>

                    <Grid container item xs={12} spacing={2} justify="center">
                        <Grid item xs={3} sm={6}>
                            <Button fullWidth variant="contained" size="medium"
                                startIcon={<ArrowBackIosIcon />}
                                onClick={onBackClick}><FormattedMessage id="Button.Back" />
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Paper>
            {(nowWainting) && <div className={classes.loadingBackground}><div className={classes.loading}><CircularProgress /></div></div>}
        </Container>
    )
}

export default withStyles(style, { withTheme: true })(PointManagementDetail);
